export const comments = [
  {
    name: 'María González',
    time: 'Hace 5 min',
    text: '¡Increíble! Ya empecé a aplicar lo que enseñas y estoy viendo resultados 🔥',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/5f5cadc626284f5fe859a590e6e61fda.jpeg'
  },
  {
    name: 'Carlos Ramírez',
    time: 'Hace 8 min',
    text: 'Esto es exactamente lo que necesitaba. Información clara y directa 💯',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/196c9656a4f653c337ab2116a852a58f.jpeg'
  },
  {
    name: 'Ana Martínez',
    time: 'Hace 12 min',
    text: 'Me encanta cómo explicas todo paso a paso. Muy profesional 👏',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/f68818875870c5344a38727b52495dd4.jpeg'
  },
  {
    name: 'Luis Fernández',
    time: 'Hace 15 min',
    text: 'Llevo 2 semanas aplicando esto y ya tengo mis primeras ventas! 🚀',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/a3263212234b6f8af28e2d0bdca2798c.jpeg'
  },
  {
    name: 'Patricia Silva',
    time: 'Hace 18 min',
    text: 'Gracias por compartir este contenido de valor. Ya me uní! 🙌',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/a245eb4e3e5d518c13b3ec00856357af.jpeg'
  },
  {
    name: 'Roberto Díaz',
    time: 'Hace 22 min',
    text: 'Excelente estrategia! Esto realmente funciona si lo aplicas bien 💪',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/2345af7ca81e597c7cc91ef49837b35e.jpeg'
  },
  {
    name: 'Sofía Torres',
    time: 'Hace 25 min',
    text: 'Me encanta tu energía y la forma en que enseñas. Sigue así! 💫',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/033245cf0036d03a51fc8d5f608b0704.jpeg'
  },
  {
    name: 'Miguel Ángel',
    time: 'Hace 28 min',
    text: 'Información de oro! Ya compartí el video con mis amigos 🔥',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/e46136b54eb7f838b2a496d3733b30e9.jpeg'
  },
  {
    name: 'Laura Mendoza',
    time: 'Hace 32 min',
    text: 'Esto es justo lo que buscaba. Contenido real y aplicable 👍',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/6cc9ffc792fa2e43ae96ae820fc8d71e.jpeg'
  },
  {
    name: 'Diego Vargas',
    time: 'Hace 35 min',
    text: 'Ya estoy dentro de la comunidad y es increíble! 100% recomendado 🎯',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/735bb0ea92d00d55078521ed1ac549b8.jpeg'
  },
  {
    name: 'Valentina Cruz',
    time: 'Hace 38 min',
    text: 'Me encanta tu energía y la forma en que enseñas. Sigue así! 💫',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/033245cf0036d03a51fc8d5f608b0704.jpeg'
  },
  {
    name: 'Javier Morales',
    time: 'Hace 42 min',
    text: 'Esto cambió mi perspectiva completamente. Gracias por el valor! 🙏',
    avatar: 'https://public.readdy.ai/ai/img_res/570cdea82ddc0494f29ead7ee337214e.jpg'
  },
  {
    name: 'Camila Rojas',
    time: 'Hace 45 min',
    text: 'Llevo 3 días aplicando esto y ya veo cambios reales! 🚀',
    avatar: 'https://public.readdy.ai/ai/img_res/6516708158b24773d87f78895afceb13.jpg'
  },
  {
    name: 'Fernando López',
    time: 'Hace 48 min',
    text: 'Contenido de calidad! Esto es lo que necesita la gente 💯',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/1857a2412fdd19103ee62f483340894c.jpeg'
  },
  {
    name: 'Isabella Sánchez',
    time: 'Hace 52 min',
    text: 'Ya me inscribí! No puedo esperar para empezar a aplicar todo 🔥',
    avatar: 'https://static.readdy.ai/image/d1d6dc2c8f1ee4e4cc3b15335751bc22/a544f28bf62d988fce8fc265a15a04c2.jpeg'
  }
];
